import React, { useEffect, useState } from 'react';
var DEFAULT_EVENTS = [
    'click',
    'focus',
    'keydown',
    'mousemove',
    'mousedown',
    'mousewheel',
    'touchstart',
    'touchmove',
    'wheel',
];
var ActivityDetection = function (_a) {
    var children = _a.children, _b = _a.events, events = _b === void 0 ? DEFAULT_EVENTS : _b;
    var _c = useState(false), active = _c[0], setActive = _c[1];
    var handleUserActivity = function () {
        setActive(true);
        unsubscribe();
    };
    var subscribe = function () {
        return events.forEach(function (eventName) { return window.addEventListener(eventName, handleUserActivity); });
    };
    var unsubscribe = function () {
        return events.forEach(function (eventName) {
            return window.removeEventListener(eventName, handleUserActivity);
        });
    };
    useEffect(function () {
        if (!active) {
            subscribe();
        }
        return unsubscribe;
    }, []);
    return React.createElement(React.Fragment, null, active && children);
};
export default ActivityDetection;
//# sourceMappingURL=ActivityDetection.js.map